const Estado = {
  MG: "Minas Gerais",
  ES: "Espírito Santo",
  SP: "São Paulo",
  PR: "Paraná",
  RO: "Rondônia",
  BA: "Bahia",
};
const Regiao = {
  SMG: "Sul de Minas Central",
  ZM1: "Mata Mineira Serrana",
  ZM2: "Mata Mineira Baixa",
  CER: "Cerrado Mineiro",
  ES1: "Caparaó e Montanhas ES",
  ES2: "Conilon Litorâneo ES",
  SP1: "Alta Mogiana e Circuito Sul",
  SP2: "Sul Paulista Serrano",
  PR: "Norte do Paraná",
  RO: "Conilon Amazônico",
  BA: "Chapada e Sul Baiano",
};
let enumStates = { Estado, Regiao };

export default enumStates;
